<template>
  <page-view title="店小赚（小程序）">
    <div :style="{marginBottom:'10px'}">
      <demo-video-alert name="LianMengPeiZhi"></demo-video-alert>
    </div>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="查询条件">
                <a-select v-model="queryParam.search_condition" placeholder="请选择" allowClear>
                  <a-select-option value="1">小程序名称</a-select-option>
                  <a-select-option value="4">小程序AppId</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="查询关键字">
                <a-input v-model="queryParam.keywords" placeholder="请输入" />
              </a-form-item>
            </a-col>
            <template v-if="advanced"></template>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
              >
                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operator">
        <a-button type="primary" @click="$refs.addModal.show()">新增小程序</a-button>
      </div>

      <s-table 
        ref="table" 
        size="default" 
        rowKey="union_id" 
        :columns="columns" 
        :data="loadData"
        :scroll="{ x: 1200 }">

        <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>

        <span slot="push" slot-scope="record">
          <a @click="pushMinApp(record)">推送小程序</a>
        </span>

        <span slot="action" slot-scope="record">
          <span v-if="record.main_id == 0">删除小程序</span>
          <a-popconfirm placement="top" @confirm="handleDelete(record.id)" v-else>
            <template slot="title">
              <p>确定要删除？</p>
              <span>删除后小程序相关功能将失效！</span>
            </template>
            <a>删除小程序</a>
          </a-popconfirm>
        </span>

      </s-table>

    </a-card>
    <add-modal ref="addModal" @ok="$refs.table.refresh(true)"></add-modal>
    <push-min-app ref="pushMinApp"></push-min-app>
  </page-view>
</template>

<script>
import { STable } from '@/components'
import CompanyApi from '@/api/company'
import { PageView } from '@/layouts'
// 新增小程序
import AddModal from './AddModal'
// 推送小程序
import pushMinApp from './pushMinApp.vue'

import { mapGetters, mapActions } from 'vuex'
import DemoVideoAlert from '@/views/components/DemoVideoAlert'

export default {
  name: 'CompanyDxzList',
  components: {
    PageView,
    STable,
    DemoVideoAlert,
    AddModal,
    pushMinApp
  },
  data() {
    return {
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          width: '80px',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '小程序名称',
          width: '250px',
          dataIndex: 'program_name'
        },
        {
          title: 'AppId(小程序ID)',
          dataIndex: 'app_id'
        },
        {
          title: '原始ID',
          width: '150px',
          dataIndex: 'origin_id',
          scopedSlots: { customRender: 'remarks_text' }
        },
        {
          title: '推送小程序',
          width: '165px',
          scopedSlots: { customRender: 'push' }
        },
        {
          title: '操作',
          width: '165px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return CompanyApi.getMinProgramList(Object.assign(parameter, this.queryParam))
      }
    }
  },
  created() {},
  methods: {
    ...mapActions(['demoSetVideo']),
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleDelete(id) {
      let loading = this.$message.loading('正在删除')
      CompanyApi.deleteMinProgram({ id: id })
        .then(res => {
          // console.log(res)
          if (res.code === 1) {
            this.$message.success('删除成功')
            this.$refs.table.refresh()
          } else {
            this.$message.error(res.msg)
          }
        })
        .finally(() => {
          this.$message.destroy(loading)
        })
    },

    // 推送小程序
    pushMinApp(record){
      this.$refs.pushMinApp.show(record)
    },
  }
}
</script>
<style lang="less" scoped>
</style>
